import React from 'react';
import {Table} from '@/web-components';
import {getQueryRenderer} from '../TaskReportUtil';
import {useGroupColumns} from './GroupColumns';

export const GroupRow = (
	data,
	rowIndex,
	searchQuery,
	groupings,
	enabledColumns,
	hasNextPage,
	fetchMore,
	nextLevelProps,
	currency,
	reportId,
	sharedId,
	customFieldColumnCount,
	customFieldKeys
) => {
	const columns = useGroupColumns(customFieldColumnCount);
	return (
		<Table.Rows
			data={data}
			canExpand={true}
			autoload={hasNextPage && rowIndex === 1}
			loadMore={hasNextPage ? fetchMore : false}
			{...nextLevelProps}
		>
			{({rowData, tableColumnsProps, nextLevelProps, expanded}) => {
				return (
					<>
						<Table.Row {...tableColumnsProps}>
							{columns.map(column => (
								<Table.Column key={column.key}>{column.Total && <column.Total row={rowData} />}</Table.Column>
							))}
						</Table.Row>
						{expanded &&
							getQueryRenderer(
								null,
								groupings,
								searchQuery,
								rowIndex,
								enabledColumns,
								data.groupingFilter(rowData),
								nextLevelProps,
								currency,
								reportId,
								sharedId,
								customFieldColumnCount,
								customFieldKeys
							)}
					</>
				);
			}}
		</Table.Rows>
	);
};
